export default "__VITE_ASSET__43d27b72__"